<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2024-01-03 11:25:19
 * @LastEditors: Merlin
 * @LastEditTime: 2024-06-26 15:40:53
 * @FilePath: /gamefi/components/Casino/History/GameContent/SpaceDice.vue
-->
<template>
    <div class="relative !select-none pointer-events-none">
        <div class="w-full p-2 relative rounded-md bg bg-[rgb(1,27,58)] column rounded-borders">
            <div class="board-mid">
                <CasinoIcon
                    style="opacity: 0.6;"
                ></CasinoIcon>
                <div class="board-mid-container">
                    <ClientOnly>
                        <BetNumberVue
                            :sound="false"
                            :sound-volume="0"
                            :fast-time="0"
                            :max-model-value="history.predictionRange[1]"
                            :min-model-value="history.predictionRange[0]"
                            :config="spaceDiceConfig"
                            :is_in="history.isIn"
                            :betAmount="betAmout"
                            :max-value="9999"
                            :min-value="0"
                        />
                    </ClientOnly>
                </div>
            </div>
            <div class="px-4">
                <ClientOnly>
                    <div class="flex flex-col relative justify-center">
                        <div class="w-full mt-8 sm:mt-2">
                            <SliderVue
                                :isIn="history.isIn"
                                v-model:label-range="labelRange"
                                :lucky-number="betAmout"
                                :bet-amount="50"
                            >
                                <template v-slot:noUISlider>
                                    <q-range
                                        :readonly="true"
                                        class="absolute inset-0 z-10 opacity-0"
                                        v-model="labelRange"
                                        key="labelRange"
                                        :min="0"
                                        :max="9999"
                                        :step="1"
                                        label-always
                                        switch-label-side
                                        drag-range
                                        thumb-color="white"
                                        :label-color="'secondary'"
                                        thumb-size="30px"
                                        :track-color="false ? 'green' : 'red'"
                                        track-size="25px"
                                        :color="true ? 'green' : 'red'"
                                    />
                                </template>
                            </SliderVue>
                        </div>
                    </div>
                </ClientOnly>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import BetNumberVue from '~/pages/casino/spacediceGame/_components/BetNumber/index.vue';
import SliderVue from '~/pages/casino/spacediceGame/_components/Slider.vue';
import CasinoIcon from '~/pages/casino/spacediceGame/_components/CasinoIcon.vue';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import { spaceDiceConfig } from '@/pages/casino/spacediceGame/js/composable';


const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});
const labelRange = ref({
    min: props.history.predictionRange[0],
    max: props.history.predictionRange[1],
});
const rangeOptions = ref([
    {
        id: 'min',
        label: 'MIN',
    },
    {
        id: 'toMin',
        label: '-5%',
    },
    {
        id: 'auto',
        label: 'AUTO PICK',
    },
    {
        id: 'toMax',
        label: '+5%',
    },
    {
        id: 'max',
        label: 'MAX',
    },
]);

const betAmout = Number(props.history.randomSeed.replace(/_.+/, ''));
</script>

<style lang="scss" scoped>
.counterTabs {
    background-color: rgb(1, 25, 56);
    border-right: 1px solid rgb(112, 138, 169);
    border-bottom: 1px solid rgb(112, 138, 169);
    border-left: 1px solid rgb(112, 138, 169);
    border-image: initial;
    border-radius: 0px 0px 10px 10px;
    border-top: none;
    height: 38px;
    width: 100%;
}

.bg {
    overflow: hidden;
    background-image: radial-gradient(rgba(0, 72, 200, 1) 0%, rgba(0, 72, 185, 0) 65%);
    background-size: 150% 83%;
    background-repeat: no-repeat;
    background-position: 54% -68%;
}


.board-mid {
    margin: 0 auto;
    max-width: 477px;
    position: relative;
    width: 100%;
    @media (max-width: 550px) {
        max-width: 312px;
    }
    .board-mid-container {
        padding-top: 10px;
        z-index: 2;
        width: 100%;
        @media (max-width: 700px) {
            width: 100%;
        }
    }
}
</style>
